import React, { useEffect, createElement } from 'react';
import { SalesPage } from './pages/SalesPage';
import { PurchasePopup } from './components/PurchasePopup';
import { FacebookPixel } from './components/FacebookPixel';
const HERO_IMAGE_URL = 'https://cdn.magicpatterns.com/uploads/8QuB2wJqs2ZConF9yjKtuA/MOCK_ED_F_NUEVO.png';
export function App() {
  // Preload the hero image as early as possible so it renders without delay.
  useEffect(() => {
    if (typeof document === 'undefined') return;
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = HERO_IMAGE_URL;
    link.fetchPriority = 'high';
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link);
    };
  }, []);
  return <>
      <FacebookPixel data-id="element-0" />
      <SalesPage data-id="element-1" />
      <PurchasePopup data-id="element-2" />
    </>;
}